import { useMemo } from 'react';
import { buildStationExportFilters } from 'utils/CommonFunction';

/**
 * Derives the station list's active filter set from its URL filter state (RAT-1677).
 *
 * The returned `exportFilters` is used twice: `StationList` spreads it into its own
 * list request and passes the same object to the export, so a "Current filter
 * results" download always matches what is on screen (AC-2) instead of relying on
 * two hand-maintained copies of eleven filters staying in step.
 *
 * Depends on the individual keys rather than the `params` object, so paging or a
 * page-size change never rebuilds it - which matters here, because the list request
 * is memoised on this value.
 *
 * Lives in a hook because StationList.jsx is close to the 1500-line lint ceiling,
 * the same reason useMerchantListFilters exists.
 */
const useStationListFilters = (params, search) => {
  const {
    sortKey,
    sortBy,
    network,
    status,
    posStatus,
    condition,
    merchantStatus,
    stockOccupancy,
    availablePBsOccupancy,
    offlineMinutesFilter,
    region,
    excludeMerchant,
    excludeUnassigned,
  } = params;

  const exportFilters = useMemo(
    () =>
      buildStationExportFilters(
        {
          sortKey,
          sortBy,
          network,
          status,
          posStatus,
          condition,
          merchantStatus,
          stockOccupancy,
          availablePBsOccupancy,
          offlineMinutesFilter,
          region,
          excludeMerchant,
          excludeUnassigned,
        },
        search,
      ),
    [
      search,
      sortKey,
      sortBy,
      network,
      status,
      posStatus,
      condition,
      merchantStatus,
      stockOccupancy,
      availablePBsOccupancy,
      offlineMinutesFilter,
      region,
      excludeMerchant,
      excludeUnassigned,
    ],
  );

  return { exportFilters };
};

export default useStationListFilters;
